export var ConnectionNames;
(function (ConnectionNames) {
    ConnectionNames["sports"] = "SportsbookConnection";
    ConnectionNames["stadium"] = "StadiumConnection";
    ConnectionNames["clank"] = "ClankConnection";
    ConnectionNames["sherpa"] = "SherpaConnection";
    ConnectionNames["wildcard"] = "WildcardConnection";
})(ConnectionNames || (ConnectionNames = {}));
export * from "./Types";
export * from "./sportsbook";
export * from "./stadium";
export * from "./clank";
export * from "./sherpa";
export * from "./wildcard";
//# sourceMappingURL=index.js.map